module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"dashbords":{"title":"Дашборды"},"header":{"qoldau":"Колдау","gsm":"Получение объемов дизельного топлива"}},"kk":{"dashbords":{"title":"Бақылау тақталары"},"header":{"qoldau":"Қолдау","gsm":"Дизель отынын қабылдау көлемдері"}}}')
  delete Component.options._Ctor
}
